// Action Types
export const SET_SIP_CONFIG = "softphone/SET_SIP_CONFIG";
export const SET_REGISTRATION_STATUS = "softphone/SET_REGISTRATION_STATUS";
export const SET_ACTIVE_CALL = "softphone/SET_ACTIVE_CALL";
export const UPDATE_CALL_STATE = "softphone/UPDATE_CALL_STATE";
export const CLEAR_ACTIVE_CALL = "softphone/CLEAR_ACTIVE_CALL";
export const SET_CALL_HISTORY = "softphone/SET_CALL_HISTORY";
export const ADD_CALL_TO_HISTORY = "softphone/ADD_CALL_TO_HISTORY";
export const SET_LOADING = "softphone/SET_LOADING";
export const SET_ERROR = "softphone/SET_ERROR";
export const SET_INCOMING_CALL = "softphone/SET_INCOMING_CALL";
export const CLEAR_INCOMING_CALL = "softphone/CLEAR_INCOMING_CALL";

// Call Flow Action Types
export const OPEN_CALL_FLOW = "softphone/OPEN_CALL_FLOW";
export const CLOSE_CALL_FLOW = "softphone/CLOSE_CALL_FLOW";
export const SET_CALL_FLOW_STEP = "softphone/SET_CALL_FLOW_STEP";
export const SET_SELECTED_CHANNEL = "softphone/SET_SELECTED_CHANNEL";
export const SET_MIC_PERMISSION_STATUS = "softphone/SET_MIC_PERMISSION_STATUS";
export const SET_ENDPOINT_PROVISION_STATUS =
  "softphone/SET_ENDPOINT_PROVISION_STATUS";
export const SET_WHATSAPP_PERMISSION = "softphone/SET_WHATSAPP_PERMISSION";
export const SET_CALL_FLOW_ERROR = "softphone/SET_CALL_FLOW_ERROR";

// Tab Coordination Action Types
export const SET_CALL_OWNER_TAB = "softphone/SET_CALL_OWNER_TAB";
export const CLEAR_CALL_OWNER_TAB = "softphone/CLEAR_CALL_OWNER_TAB";

// Mute Action Type
export const SET_MUTED = "softphone/SET_MUTED";

// Action Creators

/**
 * Set SIP configuration
 */
export const setSipConfig = (config) => ({
  type: SET_SIP_CONFIG,
  payload: config,
});

/**
 * Set SIP registration status
 */
export const setRegistrationStatus = (status) => ({
  type: SET_REGISTRATION_STATUS,
  payload: status, // 'unregistered' | 'registering' | 'registered' | 'error'
});

/**
 * Set the active call
 */
export const setActiveCall = (call) => ({
  type: SET_ACTIVE_CALL,
  payload: call,
});

/**
 * Update active call state
 */
export const updateCallState = (payload) => ({
  type: UPDATE_CALL_STATE,
  payload, // { state, previousState, reason, ...additionalData }
});

/**
 * Clear the active call
 */
export const clearActiveCall = () => ({
  type: CLEAR_ACTIVE_CALL,
});

/**
 * Set call history for a lead
 */
export const setCallHistory = (leadId, calls) => ({
  type: SET_CALL_HISTORY,
  payload: { leadId, calls },
});

/**
 * Add a call to history
 */
export const addCallToHistory = (leadId, call) => ({
  type: ADD_CALL_TO_HISTORY,
  payload: { leadId, call },
});

/**
 * Set loading state
 */
export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});

/**
 * Set error
 */
export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

/**
 * Set incoming call (when browser rings)
 */
export const setIncomingCall = (callData) => ({
  type: SET_INCOMING_CALL,
  payload: callData,
});

/**
 * Clear incoming call
 */
export const clearIncomingCall = () => ({
  type: CLEAR_INCOMING_CALL,
});

/**
 * Open call flow modal with lead info
 * @param {Object} leadInfo - { leadId, argonautLeadId, leadName, leadPhone, conversationId }
 * @param {boolean} isFirstTimeSetup - Whether this is the first time setup
 */
export const openCallFlow = (leadInfo, isFirstTimeSetup = false) => ({
  type: OPEN_CALL_FLOW,
  payload: { leadInfo, isFirstTimeSetup },
});

/**
 * Close call flow modal and reset state
 */
export const closeCallFlow = () => ({
  type: CLOSE_CALL_FLOW,
});

/**
 * Set current call flow step
 * @param {string} step - idle|setup_mic|setup_endpoint|channel_select|connecting|ringing|connected|permission_pending|error
 */
export const setCallFlowStep = (step) => ({
  type: SET_CALL_FLOW_STEP,
  payload: step,
});

/**
 * Set selected call channel
 * @param {string} channel - "pstn"|"whatsapp"
 */
export const setSelectedChannel = (channel) => ({
  type: SET_SELECTED_CHANNEL,
  payload: channel,
});

/**
 * Set microphone permission status
 * @param {string} status - "pending"|"granted"|"denied"
 */
export const setMicPermissionStatus = (status) => ({
  type: SET_MIC_PERMISSION_STATUS,
  payload: status,
});

/**
 * Set endpoint provision status
 * @param {string} status - "pending"|"provisioning"|"provisioned"|"error"
 */
export const setEndpointProvisionStatus = (status) => ({
  type: SET_ENDPOINT_PROVISION_STATUS,
  payload: status,
});

/**
 * Set WhatsApp permission info
 * @param {Object} permission - { hasPermission, isPermanent, expiresAt, isExpiringSoon }
 */
export const setWhatsappPermission = (permission) => ({
  type: SET_WHATSAPP_PERMISSION,
  payload: permission,
});

/**
 * Set call flow error message
 * @param {string} errorMessage
 */
export const setCallFlowError = (errorMessage) => ({
  type: SET_CALL_FLOW_ERROR,
  payload: errorMessage,
});

/**
 * Set the tab that owns the current call
 * @param {string} tabId
 */
export const setCallOwnerTab = (tabId) => ({
  type: SET_CALL_OWNER_TAB,
  payload: tabId,
});

/**
 * Clear call owner tab (call ended or tab closed)
 */
export const clearCallOwnerTab = () => ({
  type: CLEAR_CALL_OWNER_TAB,
});

/**
 * Set muted state
 * @param {boolean} isMuted
 */
export const setMuted = (isMuted) => ({
  type: SET_MUTED,
  payload: isMuted,
});
